<template>
  <div class="container">
    <!-- <a-alert
        message="此处设置项的修改将会影响系统运行，如您不清楚配置项的作用，请在询问后再进行修改。"
        type="warning"
        style="margin-bottom:24px"
        show-icon
        banner
    /> -->

    <div class="main">
      <a-form-model :model="form" :label-col="label_col" :wrapper-col="wrapper_col" class="form" labelAlign="left">
        <h2 class="h2">基本设置</h2>
        <a-form-model-item label="开启登录功能" extra="关闭后客户将会登录平台">
          <a-switch v-model="form.enable_login" />
        </a-form-model-item>

        <a-form-model-item label="开启注册功能" extra="关闭后客户将会无法注册平台">
          <a-switch v-model="form.enable_signup" />
        </a-form-model-item>

        <a-form-model-item label="开启下单功能" extra="关闭后客户将无法使用下单以及店铺预定功能">
          <a-switch v-model="form.enable_order" />
        </a-form-model-item>

        <a-form-model-item label="单次充值最小金额" extra="填写0则表示没有限制">
          <a-input v-model="form.recharge_amount_min" addon-after="元"></a-input>
        </a-form-model-item>

        <a-form-model-item label="单次充值最大金额" extra="填写0则表示没有限制">
          <a-input v-model="form.recharge_amount_max" addon-after="元"></a-input>
        </a-form-model-item>

        <a-form-model-item label="节假日分配开关">
          <a-switch v-model="form.distribute" />
        </a-form-model-item>

        <a-form-model-item label="分配销售列表">
          <a-select
            mode="multiple"
            :value="form.sale_list"
            optionFilterProp="children"
            placeholder="输入销售名称或ID搜索"
            style="width: 400px"
            @change="handleChange"
          >
            <a-select-option v-for="d in salerData" :key="d.id">
              {{ d.id + " " + d.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-divider />

        <h2 class="h2">订单相关设置</h2>

        <a-form-model-item label="定金比例" extra="订单总金额的预算定金，请填写小数">
          <a-input v-model="form.order_deposit_pct"></a-input>
        </a-form-model-item>

        <a-form-model-item label="定金支付期限" extra="订单创建后支付定金的期限">
          <a-input v-model="form.order_deposit_deadline" addon-after="天数"></a-input>
        </a-form-model-item>

        <a-form-model-item label="验店期限" extra="验店成功后合同签署的期限">
          <a-input v-model="form.order_verify_deadline" addon-after="天数"></a-input>
        </a-form-model-item>

        <a-form-model-item label="合同签署期限" extra="验店成功后合同签署的期限">
          <a-input v-model="form.order_contract_deadline" addon-after="天数"></a-input>
        </a-form-model-item>

        <a-form-model-item label="尾款期限" extra="合同签署成功后支付尾款的期限">
          <a-input v-model="form.order_balance_deadline" addon-after="天数"></a-input>
        </a-form-model-item>

        <a-form-model-item label="允许修改结束后的订单" extra="订单结束或者完成是否允许修改信息">
          <a-switch v-model="form.order_complete_editable" />
        </a-form-model-item>

        <a-form-model-item label="自动分配订单" extra="客户下单后自动将订单分配给其所设置的业务员">
          <a-switch v-model="form.order_distribute_auto" />
        </a-form-model-item>

        <!-- <a-form-model-item label="列表页显示客户社交头像" extra="头像来自客户所关联的社交平台头像">
        <a-switch v-model="form.display_social_avatar" />
    </a-form-model-item>

    <a-form-model-item label="启用友好时间" extra="使用例如【xx分钟】前代替标准的时间格式">
        <a-switch v-model="form.display_friendly_date" />
    </a-form-model-item> -->

        <!-- <h2 class="h2">积分以及交易设置</h2>
    <a-divider/>
    <a-form-model-item label="启用兑换消费积分" extra="客户消费时，自动根据消费的积分比例计算积分">
        <a-switch v-model="form.enable_point_exchange" />
    </a-form-model-item>


    <a-form-model-item label="仅赠送已注册用户" extra="仅对已经注册（移动端）且登录过的用户赠送积分，未在移动端登录过的用户将无法获得积分">
        <a-switch v-model="form.enable_point_registered" />
    </a-form-model-item>


    <a-form-model-item label="启用积分赠送" extra="如果已经设置了积分赠送规则，可以在此统一开启或者关闭">
        <a-switch v-model="form.enable_point_present" />
    </a-form-model-item> -->

        <!-- <a-form-model-item label="" extra="如果已经设置了积分赠送规则，可以在此统一开启或者关闭">
        <a-switch v-model="form.enable_point_present" />
    </a-form-model-item> -->
        <a-divider />

        <h2 class="h2">通知相关设置</h2>

        <a-form-model-item label="启用短信通知" extra="关闭短信通知功能，客户在任何情况下都不会收到除验证码外的其他短信通知">
          <a-switch v-model="form.enable_sms_notify" />
        </a-form-model-item>

        <a-form-model-item label="启用钉钉消息通知" extra="如果已经配置了钉钉相关通知，可以在此统一进行开启或关闭">
          <a-switch v-model="form.enable_dd_notify" />
        </a-form-model-item>
        <a-divider />

        <h2 class="h2">安全以及权限相关设置</h2>
        <a-form-model-item label="启用登录限制" extra="关闭非IP白名单内的访问权限">
          <a-switch v-model="form.enable_ip_restrict" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" :disabled="submitting || loading" @click="on_submit">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
let form_init = {
  enable_login: true,
  enable_signup: false,
  order_deposit_pct: null,
  order_deposit_deadline: null,
  order_verify_deadline: null,
  order_contract_deadline: null,
  order_balance_deadline: null,
  order_complete_editable: false,
  enable_ip_restrict: false,
  enable_dd_notify: true,
  enable_sms_notify: true,
  tmall_price_est_pct: null,
  enable_order: false,
  recharge_amount_min: null,
  recharge_amount_max: null,
  distribute: false,
  order_resource_limit: null,
  order_distribute_auto: false,
  tmall_service_pct: null,
  sale_list: []
};
export default {
  data() {
    return {
      label_col: { span: 4 },
      wrapper_col: { span: 14 },
      submitting: false,
      loading: false,
      form: {},
      assignSaler: [],
      salerData: []

    };
  },
  created() {
    this.form = JSON.parse(JSON.stringify(form_init));
    this.load();
    this.fetchSaler();
  },
  methods: {
    load() {
      this.loading = true;
      this.$http
        .get("/setting/general", this.form)
        .then((res) => {
          if (res.success) {
            const data = res.data;
            data["order_complete_editable"] = !!res.data.order_complete_editable;
            data["enable_dd_notify"] = !!res.data.enable_dd_notify;
            data["enable_sms_notify"] = !!res.data.enable_sms_notify;
            data["enable_ip_restrict"] = !!res.data.enable_ip_restrict;
            data["enable_signup"] = !!res.data.enable_signup;
            data["enable_login"] = !!res.data.enable_login;
            data["enable_order"] = !!res.data.enable_order;
            data["order_distribute_auto"] = !!res.data.order_distribute_auto;
            data["distribute"] = !!res.data.distribute;

            this.form = data;

          }
        })
        .catch(() => {
        })
        .then(() => {
          this.loading = false;
        });
    },
    on_submit() {
      this.submitting = true;
      this.$http
        .post("/setting/general", this.form)
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message);
            this.load_config();
          } else {
            this.$error({ title: "失败", content: res.message });
          }
        })
        .catch(() => {
        })
        .then(() => {
          this.submitting = false;
        });
    },
    fetchSaler() {
      this.$http.get("/auth/user/accessible")
        .then((res) => {
          if (res.success) {
            this.salerData = res.data;
          }
        });
    },
    handleChange(value) {
      this.form.sale_list = value;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  .main {
    top: 0 !important;
    padding-top: 12px;
    padding-left: 24px;

    .ant-input,
    .ant-input-group-wrapper {
      max-width: 200px;
    }
  }
}
</style>
